import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { CSVLink } from 'react-csv';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useNavigate } from 'react-router-dom';
import Logo from '../assets/loyaltap_logo.png';
import './AiSuggestions.css';
import { useTranslation } from 'react-i18next';


const AiSuggestions = () => {
  const { t, i18n } = useTranslation();
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSuggestions = async () => {
      const coffeeShopId = localStorage.getItem('coffee_shop_id');
      if (!coffeeShopId) return console.warn("⚠️ Missing coffee_shop_id");
  
      const q = query(
        collection(db, "ai_suggestions"),
        where("coffee_shop_id", "==", coffeeShopId),
        orderBy("createdAt", "desc")
      );
      const snapshot = await getDocs(q);
      setSuggestions(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
  
    fetchSuggestions();
  }, []);

  const sentimentData = [
    { name: 'General', value: suggestions.filter(s => s.type === 'general').length },
    { name: 'Employee', value: suggestions.filter(s => s.type === 'employee').length },
  ];

  const hasSentimentData = sentimentData.some(item => item.value > 0);
  const COLORS = ['#4CAF50', '#FFC107'];

  return (
    <div className="suggestions-container">
      <div className="logo">
        <img src={Logo} alt="LoyalTap Logo" className="logo-image" />
      </div>

      <h2>🤖 {t('ai_insights')}</h2>
<p style={{ color: 'gray', fontStyle: 'italic', marginBottom: '1rem' }}>
  {t('ai_note_english_only')}
</p>

      {hasSentimentData ? (
        <ResponsiveContainer width="100%" height={250}>
          <PieChart>
            <Pie data={sentimentData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80}>
              {sentimentData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      ) : (
        <p>No insights available yet.</p>
      )}

      <CSVLink data={suggestions} filename={"ai_suggestions.csv"} className="export-btn">
        📥 Export AI Insights (CSV)
      </CSVLink>
      <button className="export-btn2" onClick={() => navigate('/customer-reviews')}>
          🌟 See Customer Reviews
        </button>
      <button className="export-btn1" onClick={() => navigate('/dashboard')}>
        ⬅️ Back to Dashboard
      </button>

      {suggestions.map((s, index) => (
        <div key={s.id} className="suggestion-card">
          <h3>{s.title}</h3>
          {s.employee_name && (
            <p><strong>Employee:</strong> {s.employee_name}</p>
          )}
          <div className="suggestion-content">
            {s.suggestion.split(/\d+\.\s/).filter(text => text.trim() !== "").map((text, idx) => (
              <p key={idx}>
                <strong>{idx + 1}.</strong> {text.trim()}
              </p>
            ))}
          </div>
          {s.createdAt && (
            <small>{new Date(s.createdAt.seconds * 1000).toLocaleString()}</small>
          )}
        </div>
      ))}
    </div>
  );
};

export default AiSuggestions;